import React from 'react';
import {Button, Form, Icon} from 'antd';
import PropTypes from 'prop-types';
import {getSubFormFieldByType} from '../../util/methods';
import ComplaintModal from "../ComplaintModal";

class SubList extends React.Component {

  id = 0;

  state = {
    keys: [],
  };

  componentDidMount() {
    const { data = [] } = this.props;
    this.setState({
      keys: data,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
  }

  remove = index => {
    const { keys } = this.state;
    const { form, item } = this.props;
    const { field } = item;
    if (keys.length === 0) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i< val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  render() {
    const { form, item, data = [], hideAddButton = false, resource } = this.props;
    const { field } = item;
    const { getFieldDecorator } = form;
    const { keys } = this.state;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
            if (fieldName !== 'complaint') {
              return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, { title: 'CREATE', resource });
            } else {
              return <ComplaintModal history={this.props.history} match={this.props.match} key={item} item={item} form={form} data={[]} getComplaintData={this.props.getComplaintData} complaints={this.props.complaints}/>
            }
          })
        }

        {index >= 0 && !hideAddButton ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index)}
          />
        ) : null}
      </div>
    ));

    return (
      <div>
        {formItems}

        {
          this.props && this.props.hideAddButton ? <br/> : <Form.Item>
            <Button type="dashed" onClick={this.add} style={{ width: '60%', marginTop: '15px' }}>
              <Icon type="plus"/> Add Asset Reading
            </Button>
          </Form.Item>
        }

      </div>

    );
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
